export default __webpack_public_path__ + "static/media/feature3_1.09f0c42b.png";